import { createSlice } from '@reduxjs/toolkit';
import config from '../../config';

const initialState = {
  selectedMosadCode: null,
  mosadData: null,
  mosadToken: null,
  firstLoginCompleted: false,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedMosad: (state, action) => {
      // Store only the mosad code
      state.selectedMosadCode = action.payload?.code || null;
      // Store in localStorage for persistence
      if (action.payload?.code) {
        localStorage.setItem(config.APP_NAME + '_selectedMosadCode', action.payload.code);
      } else {
        localStorage.removeItem(config.APP_NAME + '_selectedMosadCode');
      }
    },
    setFirstLoginCompleted: (state, action) => {
      state.firstLoginCompleted = action.payload;
      localStorage.setItem(config.APP_NAME + '_firstLoginCompleted', action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setMosadData: (state, action) => {
      state.mosadData = action.payload || null;
      state.mosadToken = action.payload?.mosadToken || null;
      // Store in localStorage for persistence
      if (action.payload?.mosadToken) {
        localStorage.setItem(config.APP_NAME + '_mosadToken', action.payload.mosadToken);
      } else {
        localStorage.removeItem(config.APP_NAME + '_mosadToken');
      }
    },
    clearUserState: (state) => {
      state.selectedMosadCode = null;
      state.mosadData = null;
      state.mosadToken = null;
      state.loading = false;
      state.error = null;
    },
  },
});

// Load initial state from localStorage
const loadInitialState = () => {
  try {
    const selectedMosadCode = localStorage.getItem(config.APP_NAME + '_selectedMosadCode');
    const firstLoginCompleted = localStorage.getItem(config.APP_NAME + '_firstLoginCompleted');
    const mosadToken = localStorage.getItem(config.APP_NAME + '_mosadToken');
    return {
      ...initialState,
      selectedMosadCode: selectedMosadCode || null,
      firstLoginCompleted: firstLoginCompleted === 'true',
      mosadToken: mosadToken || null,
    };
  } catch (error) {
    console.error('Error loading user state from localStorage:', error);
    return initialState;
  }
};

// Export actions
export const {
  setSelectedMosad,
  setMosadData,
  setFirstLoginCompleted,
  setLoading,
  setError,
  clearUserState,
} = userSlice.actions;

// Export reducer
export default userSlice.reducer;

// Export initial state loader
export const loadUserInitialState = loadInitialState; 